import EditActivityLog from './EditActivityLog';

export default EditActivityLog;
